// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as NewsRouteImport } from './routes/news'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as LearnSlugRouteImport } from './routes/learn.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as NewsSlugRouteImport } from './routes/news.$slug'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const LearnSlugRoute = LearnSlugRouteImport.update({
            id: '/learn/$slug',path: '/learn/$slug',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => NewsRoute
          })





const NewsRouteChildren = {
  NewsSlugRoute: NewsSlugRoute
}

const NewsRouteWithChildren = NewsRoute._addFileChildren(NewsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,NewsRoute: NewsRouteWithChildren,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TermsRoute: TermsRoute,BlogSlugRoute: BlogSlugRoute,LearnSlugRoute: LearnSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)